import styled from '@emotion/styled';

export const SOff = styled.div`
  position: absolute;
  border: 3px solid #e53935;
  border-radius: 6px;
  color: #e53935;
  background: #fff;
  width: 52px;
  height: 24px;
  font-size: 14px;
  transform: rotate(-15deg);
  top: -12px;
  left: -8px;
`;
